import React from 'react'

const SummaryCard = ({title, total, rate, duration, increased, icon, borderColor}) => {
  return (
    // <div className="card widget-flat rounded-0">
    //     <div className={`card-body border-2 border-start border-${borderColor}`}>
    //         <div className="float-end">
    //             <i className={`${icon.class} widget-icon rounded-circle`} style={{background: icon.bg, color: icon.color}}></i>
    //         </div>
    //         <h5 className="text-muted fw-normal mt-0" title="Number of Customers">{title}</h5>
    //         <h3 className="mt-3 mb-3">{total}</h3>
    //         <p className={`mb-0 text-muted ${!rate && 'invisible'}`}>
    //             <span className={`text-${increased ? 'success' : 'danger'} me-2`}>
    //                 <i className={`mdi mdi-arrow-${increased ? 'up' : 'down'}-bold`}></i> {rate} </span>
    //             <span className="text-nowrap">{duration}</span>  
    //         </p>
    //     </div> 
    //     {/* <!-- end card-body--> */}
    // </div> 
    <div className="card widget-flat rounded-0">
        <div className={`card-body d-flex flex-row align-items-center gap-1`}>
            <div className=" flex-shrink-0" style={{width: "70px", height: "70px",}}>
                <div className="d-flex justify-content-center align-items-center w-full h-full rounded-circle" style={{background: icon.bg}}>
                <i
                    className={`${icon.class} widget-icon rounded-circle icon d-block`}
                    style={{
                        background: "transparent",
                        color: icon.color,
                        width: "40px",   // Increased width
                        height: "40px",  // Increased height
                        fontSize: "30px", // Adjust font size for the icon itself
                    }}
                ></i>
                </div>
            </div>
            <div>
                <h3 className="mb-1">{total}</h3>
                <h5 className="text-muted fw-normal mt-0" title="Number of Customers">{title}</h5>
            </div>
        </div> 
    </div> 
  )
}

export default SummaryCard